(function(){
  function init(root){
    var track=root.querySelector('.rv-track');
    if(!track||track.dataset.rvInit)return;
    track.dataset.rvInit='1';
    function step(){var c=track.querySelector('.rv-card');return c?c.offsetWidth+12:300;}
    var prev=root.querySelector('.rv-prev'),next=root.querySelector('.rv-next');
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    var down=false,sx=0,ss=0;
    track.addEventListener('pointerdown',function(e){
      if(e.pointerType!=='mouse')return;
      down=true;sx=e.clientX;ss=track.scrollLeft;
      track.classList.add('rv-dragging');
      e.preventDefault();
    });
    window.addEventListener('pointermove',function(e){
      if(down)track.scrollLeft=ss-(e.clientX-sx);
    });
    window.addEventListener('pointerup',function(){
      if(!down)return;down=false;
      var s=step(),t=Math.round(track.scrollLeft/s)*s;
      track.scrollTo({left:t,behavior:'smooth'});
      setTimeout(function(){track.classList.remove('rv-dragging');},400);
    });
  }
  function boot(){document.querySelectorAll('.rv-section').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.rv-section');if(r)init(r);});
})();
